import type { IMgmSharedResources } from "@/src/member-get-member/shared/MgmShared.Resources";

export const MgmSharedResourcesEn: IMgmSharedResources = {
    mgmHowItWorks: {
        title: "How it <b>works</b>?",
        item1Text:
            "<b>You send a referral link or code to a friend, who has not previously made purchases through goodie cashback.</b> You can make your own code or use ready-to-use one.",
        item2Text:
            "Your friend need to <b>sign up to goodie using your referral link</b> or by entering using your referral code.",
        item3Text:
            "During 30 days your friend needs to <b>do purchases using goodie cashback spending at least 80 zł.</b>",
        item4Text: "Well done! You and Your friend <b>receive bonus!</b>",
    },

    mgmTransactionSummary: {
        modalTitle: "Your bonuses for recommendations",
        tabPending: "Pending",
        tabApproved: "Accepted",
        tabRejected: "Rejected",
        noTransactionTitle: "No rejected bonuses",
        noTransactionDescription:
            "If your friend don't do purchase during 90 days from the registration, you will see the list of not granted bonuses here.",
        usersRegisteredToMeLabel: "Registered from your account users",
        completedBonusLabel: "Completion of the bonus: ",
        beforeCompletedBonusLabel: "Before completing the bonus: ",
        totalBonusReceivedLabel: "Current payout: {totalAmount}",
        tableHeaderDateLabel: "Date of the registration",
        tableHeaderAmountLabel: "Bonus amount",
        tableHeaderStatusLabel: "Status",
    },

    noPendingBonus: {
        label: "No pending bonuses",
        text: "When recommended friends register to goodie, you will see pending bonuses for the recommendation here.",
    },
    noApprovedBonus: {
        label: "No approved bonuses",
        text: "When recommended friends do first purchase with goodie cashback, you will see granted bonuses ready for withdrawal.",
    },
    noRejectedBonus: {
        label: "No rejected bonuses",
        text: "If your friend don't do purchase during 90 days from the registration, you will see the list of not granted bonuses here.",
    },

    mgmNumbersSummary: {
        title: "<b>Summary</b>",
        step1: "Your pending bonuses",
        step2: "Your accrued bonuses",
        step3: "Users registered by your referral",
        openSummaryBtnLabel: "See details",
    },
};
